<template>
  <header class="profile_header">
    <div v-if="isLoaded" class="profile_header_content bg-white">
      <div class="profile_header_content_show container-fluid">
        <div class="row py-4">

          <div class="col-12 d-flex">
            <!-- picture -->
            <profile-picture :user="user" :researcher="researcher" />

            <div class="pl-3">
              <!-- name -->
              <h1 class="d-flex align-items-baseline t-grey">
                <span v-if="researcher.academic_title" class="t-xxxs pr-2 t-500">{{ researcher.academic_title }}</span>
                <span v-html="fullName" class="t-500 mr-2" />
                <!-- edit researcher -->
                <span v-if="$can.edit('researcher', user.rw_access) && $route.name ==='researcher.show'">
                  <link-button
                    icon="fa fa-pencil t-sm pr-2"
                    @click="openModal('first_name')"
                    text="Edit"
                  />

                  <link-button
                    v-if="!isEmpty(researcher.highlights) && isEmpty(researcher.highlights.organisations)"
                    icon="fa fa-plus t-sm pr-2"
                    @click="openOrganisationModal()"
                    text="Add your company/institution"
                  />
                </span>
              </h1>

              <!-- organisation -->
              <linked-list-collapsible
                v-if="!isEmpty(researcher.highlights) && !isEmpty(researcher.highlights.organisations)"
                :items="researcher.highlights.organisations"
                scope="organisation"
                showFlags
                class="d-inline-block"
              />

              <!-- research groups -->
              <linked-list-collapsible
                v-if="!isEmpty(researchGroups)"
                :items="researchGroups"
                scope="research_group"
                showWebsites
                class="d-inline-block"
              />

            </div>
          </div>
        </div>
      </div>

      <sub-nav v-if="isLoaded"
        :name="`researcher_header_nav`"
        :text="true"
        :rw_access="user.rw_access"
        :user="user"
        :researcher="researcher"
        :counts="counts"
        :hasResearch="hasResearch"
      />

    </div>
    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </header>
</template>

<script>
import ProfilePicture from '@/components/researcher/show/Picture'
import SubNav from '@/components/shared/nav/SubNav'
import Spinner from '@/components/shared/Spinner'
import LinkedListCollapsible from '@/components/shared/LinkedListCollapsible'
import LinkButton from '@/components/shared/form/LinkButton'

export default {
  name: 'researcherHeader',
  components: {
    ProfilePicture,
    SubNav,
    Spinner,
    LinkedListCollapsible,
    LinkButton
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    },
    hasResearch: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    counts () {
      return {
        manage_invitations: {
          total: this.user.pending_invites_count,
          color: 'green'
        },
        bookmark_folders: {
          total: this.user.bookmark_folder_count
        }
      }
    },
    researchGroups () {
      return !this.isEmpty(this.researcher.research_groups)
        ? this.researcher.research_groups.filter(rg => rg.slug_values && rg.slug_values.length > 0).slice(0, 4)
        : []
    },
    fullName () {
      if (!this.isEmpty(this.researcher.highlights)) {
        if (!this.isEmpty(this.researcher.highlights.full_name)) return this.researcher.highlights.full_name
        if (!this.isEmpty(this.researcher.highlights.initial_name)) return this.researcher.initial_name
      }
      return this.getFullName(this.researcher)
    }
  },
  methods: {
    openModal (focus) {
      this.$events.$emit('modal:researcher:edit:open', this.researcher, focus)
    },
    openOrganisationModal () {
      this.$events.$emit('modal:organisation:create:open', this.user, this.researcher)
    }
  }
}
</script>
